import { render } from "./TipoServicio.vue?vue&type=template&id=29c2c1bc"
import script from "./TipoServicio.vue?vue&type=script&lang=js"
export * from "./TipoServicio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__